import { getBetHistoryDetailsUrl } from '../blackJackCore/helpers';
import { httpClient } from '../../../services/http';
import { detectSocketPath } from '../../../core/constants/socketPathName';
import { environmentBuilder } from '../../../core/helpers/environmentBuilder';

class BetHistoryDetailsService {
  constructor({ url }) {
    this.url = url;
  }

  getBetHistory(params) {
    return httpClient.get(getBetHistoryDetailsUrl(this.url), { params });
  }
}

const gameName = detectSocketPath(
  window.location.pathname === '/' ? '/crypto-crash/' : window.location.pathname
);

const { httpUrl } = environmentBuilder(gameName);

export const betHistoryDetailsService = new BetHistoryDetailsService({ url: httpUrl });
